module.exports = __webpack_public_path__ + "static/img/my-register.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/my-register.png
// module id = 577
// module chunks = 0